import { UserModalLocale } from "..";

const locale: UserModalLocale = {
  principal_name: '登录名称',
  display_name: '显示名称',
  email: '邮箱',
  mobile: '手机',
  status: '状态',
  created_at: '创建事件',
};

export default locale
